import { useAdminInvoiceReportsSearch } from '@/context/services/admin_invoice_reports/AdminInvoiceReports.service';
import type {
  AdminInvoiceReportsSearchQuery,
  FetchAdminInvoiceReportsArgs,
  OrderByItem,
} from '@/features/admin_invoice_reports/types';
import { useFlashToast } from '@/hooks/useFlashToast';
import { isCommonError } from '@/libs/typeguard/isError';
import { useCallback, useEffect, useState } from 'react';

export const useAdminInvoiceReportsSearchData = (
  args: FetchAdminInvoiceReportsArgs = {},
  setError: (error: Error) => void
) => {
  const { data, pagination, refetch, isFetching, isError, error } =
    useAdminInvoiceReportsSearch(args);

  const [isInitialError, setIsInitialError] = useState(true);

  useFlashToast();

  const handleError = useCallback(() => {
    const errorMessage =
      isCommonError(error ?? {}) && Array.isArray(error?.messages)
        ? error?.messages.join('')
        : String(error?.messages);
    if (errorMessage !== null && errorMessage !== 'undefined') {
      setError({
        name: 'AdminInvoiceReportsTableError',
        message: String(errorMessage),
      });
    }
  }, [error, setError]);

  useEffect(() => {
    if (isInitialError && isError && !isFetching) {
      setIsInitialError(false);
      handleError();
      return;
    }
    if (isError && !isFetching) {
      handleError();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching, isInitialError]);

  return { data, pagination, refetch, isFetching };
};

export type { AdminInvoiceReportsSearchQuery, OrderByItem };
